<template>
  <div width="235px" class="geo-filter">
    <v-expansion-panels v-model="expend">
      <v-expansion-panel @click="panel">
        <v-expansion-panel-header color="#00475A" hide-actions>
          {{ $t("message.page.findLocation", { value: "default" }) }}
        </v-expansion-panel-header>
        <v-expansion-panel-content color="#00475A">
          <!--locos-->
          <v-autocomplete
            :items="this.locoList"
            @change="emitData"
            item-text="loconum"
            item-value="loconum"
            dense
            solo
            outlined
            background-color="#fff"
            color="#00475A"
            hide-details
            v-model="payload.locomotives[0]"
            :label="$t('message.pageKm.loco', { value: 'default' })"
          >
            <template v-slot:selection="{ item }">
              <span>{{ item.loconum }}</span>
            </template>
          </v-autocomplete>

          <div v-if="!payload.locomotives.length" class="infoFilter mb-5">
            <i>{{ $t("message.page.filterMsg", { value: "default" }) }}</i>
          </div>

          <!--startdate-->
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            style="margin-top: 1em;"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :label="$t('message.page.startDate', { value: 'default' })"
                readonly
                :value="startDateDisp"
                v-on="on"
                outlined
                dense
                class="mb-1"
                hide-details
                solo
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startDateVal"
              no-title
              @input="startDateMenu = false"
              @change="refreshDate"
            ></v-date-picker>
          </v-menu>
          <!--startdate-->
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :label="$t('message.page.endDate', { value: 'default' })"
                readonly
                :value="endDateDisp"
                v-on="on"
                outlined
                dense
                hide-details
                solo
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="endDateVal"
              no-title
              @input="endDateMenu = false"
              @change="refreshDate"
            ></v-date-picker>
          </v-menu>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-btn tile small color="#6DB7A2" style="width: 62px" @click="toggle">
        <v-icon color="#fff">{{ expendIcon }}</v-icon>
      </v-btn>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  firstDateOfCurrentMonth,
  currentDate,
  parseDate,
  formatDate,
} from "@/shared/DateHelper";
export default {
  watch: {
    getterCurrentClient: function () {
      this.loadLocos();
      this.initializeDates();
      this.initalizePayload();
      this.refreshDate();
    },
  },
  methods: {
    ...mapActions("customer", {
      actionGetLocos: "loadLocos",
    }),

    extractLoco(data) {
      let locos = [];
      var i;
      for (i = 0; i < data.length; i++) {
        locos.push(data[i].loconum);
      }
      return locos;
    },

    panel() {
      if (this.expend == 0) {
        this.expendIcon = "mdi-chevron-down";
      } else {
        this.expendIcon = "mdi-chevron-up";
      }
    },

    getLocale(value) {
      if (value == "Titulaire") {
        return "message.page.titular";
      }

      if (value == "Reserve") {
        return "message.page.reserve";
      }

      if (value == "Performance") {
        return "message.page.performance";
      }

      if (value == "Spot") {
        return "message.page.spot";
      }
    },

    toggle() {
      if (this.expend == 0) {
        this.expend = null;
        this.expendIcon = "mdi-chevron-down";
      } else {
        this.expend = 0;
        this.expendIcon = "mdi-chevron-up";
      }
    },

    async loadLocos() {
      let payload = {
        customer: this.getterCurrentClient,
        start: firstDateOfCurrentMonth(),
        end: currentDate(),
      };
      await this.actionGetLocos(payload);
      this.items = this.getterLocos;
      this.serailList = this.getterLocos;
      this.locoList = this.getterLocos;
      this.statusList = this.getterLocos;
    },

    initializeDates() {
      this.startDateVal = formatDate(firstDateOfCurrentMonth());
      this.endDateVal = formatDate(currentDate());
    },

    initalizePayload() {
      this.payload.startdate = firstDateOfCurrentMonth();
      this.payload.enddate = currentDate();
      this.payload.clients = [this.getterCurrentClient];
      this.payload.contrats = [];
      this.payload.series = [];
      this.payload.locomotives = [];
    },

    refreshDate() {
      this.payload.enddate = parseDate(this.endDateVal);
      this.payload.startdate = parseDate(this.startDateVal);
      this.emitData();
    },

    emitData() {
      this.$emit("filter", this.payload);
    },
  },

  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
    }),
    ...mapGetters("customer", {
      getterCustomer: "getCustomer",
      getterLocos: "getLocos",
    }),

    selectAllLoc() {
      if (this.payload.locomotives == null) return false;
      return this.locoList.length === this.payload.locomotives.length;
    },

    selectSomeLoc() {
      if (this.payload.locomotives == null) return false;
      return this.payload.locomotives.length > 0 && !this.selectAllLoc;
    },

    icon() {
      if (this.selectAllLoc) return "mdi-close-box";
      if (this.selectSomeLoc) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    endDateDisp() {
      return this.endDateVal;
    },

    startDateDisp() {
      return this.startDateVal;
    },
  },
  name: "PortalGeoFilter",
  mounted() {
    this.loadLocos();
    this.initializeDates();
    this.initalizePayload();
  },
  data: () => ({
    items: [],
    expend: 0,
    expendIcon: "mdi-chevron-down",
    serailList: [],
    locoList: [],
    statusList: [],
    vstatus: [],
    endDateVal: null,
    endDateMenu: false,
    startDateVal: null,
    startDateMenu: false,
    payload: {
      startdate: null,
      enddate: null,
      clients: null,
      contrats: null,
      series: null,
      locomotives: [],
    },
  }),
};
</script>


<style scoped>
.infoFilter {
  color: #fff;
  font-size: 12px;
}

.geo-filter {
  position: fixed;
  z-index: 1099;
  top: 250px;
  left: 309px;
  width: 235px;
}

.geo-filter > * {
  z-index: 1100;
}

button {
  color: #fff;
}
</style>